module.exports = __webpack_public_path__ + "trust-marks-marketing-profs.bf59d5.png";